import { action } from 'cdpro-redux-utils'

import { Platforms } from './types'

export const setWelcomeMessage = action<{ message: string }>('@welcome/SET_MESSAGE')
export const Types = {
  User: {
    SET_USER_ACCOUNT: '@user/SET_USER_ACCOUNT',
  },
  CPF: {
    SET_USER_CPF: '@hub/SET_USER_CPF',
  },
  DARK_MODE: {
    SET_DARK_MODE: '@hub/SET_DARK_MODE',
  },
  CEL: {
    SET_USER_CEL: '@hub/SET_USER_CEL',
  },
  FIRST_NAME: {
    SET_FIRST_NAME: '@hub/SET_FIRST_NAME',
  },
  HOME_CREDIT_ONBOARDING: {
    SET_HOME_CREDIT_ONBOARDING: '@home-credit-onboarding/SET_HOME_CREDIT_ONBOARDING',
  },
  MobilePlatform: {
    SET_MOBILE_PLATFORM: '@MobilePlatform/SET_MOBILE_PLATFORM',
  },
  API_PATH: {
    SET_API_REQUEST: '@api/SET_API_REQUEST',
  },
  SKELETON: {
    SET_SKELETON: '@skeleton/SET_SKELETON',
  },
  App: {
    SET_TYPE: '@app/SET_TYPE',
  },
  GLOBAL_BOTTOM_SHEET: {
    OPEN: '@global-bottom-sheet/OPEN',
    CLOSE: '@global-bottom-sheet/CLOSE',
  },
}
export const setUserAccount = action<{ account: string }>(Types.User.SET_USER_ACCOUNT)

export const setUserCel = action<{ cel: string }>(Types.CEL.SET_USER_CEL)

export const setFirstName = action<{ firstName: string }>(Types.FIRST_NAME.SET_FIRST_NAME)

export const setAppType = action<{ appType: string | undefined }>(Types.App.SET_TYPE)

export const setDarkMode = action<{ isDarkMode: boolean }>(Types.DARK_MODE.SET_DARK_MODE)

export const setMobilePlatform = action<Platforms>(Types.MobilePlatform.SET_MOBILE_PLATFORM)

export const setHomeCreditOnboarding = action<{
  homeCreditOnboarding: HomeCreditOnboardingResponse
}>(Types.HOME_CREDIT_ONBOARDING.SET_HOME_CREDIT_ONBOARDING)

export const setApiRequest = action<{ apiRequest: string | undefined }>(
  Types.API_PATH.SET_API_REQUEST,
)

export const setSkeleton = action<{ skeleton: Skeleton | undefined }>(Types.SKELETON.SET_SKELETON)

export const openGlobalBottomSheet = action<{
  title?: string
  expansible?: 'on' | 'off'
  position?: 'hug' | string
  components: Array<{
    id: string
    type: string
    style?: ComponentStyle
    props?: Record<string, unknown>
    path?: string
  }>
}>(Types.GLOBAL_BOTTOM_SHEET.OPEN)

export const closeGlobalBottomSheet = action<Record<string, never>>(Types.GLOBAL_BOTTOM_SHEET.CLOSE)
